export default "What time frame would you like to see on the chart?";